import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/ConsumptionMeteringPointGroup.module.scss';

import { OmaLummeApp } from '../../../omaLummeContext';

import { useWindowSize } from '../../Layout/Header';

import Button from '../../Common/Button';
import Dialog from '../../Common/Dialog';
import Loading from '../../Common/Loading';
import ConsumptionMeteringPointGroupNew from './ConsumptionMeteringPointGroupNew';
import ConsumptionMeteringPointGroupAccordion from './ConsumptionMeteringPointGroupAccordion';
import ConsumptionMeteringPointGroupEdit from './ConsumptionMeteringPointGroupEdit';

// Actions.
import { fetchMeteringPointGroups } from '../../../actions';
// Types
import { MeteringPointGroup } from '../../../types/consumptionRates';

const ConsumptionMeteringPointGroupManage: React.FunctionComponent = () => {
  const { users } = OmaLummeApp.useState();
  const { userId } = users.activeUser;
  const { t } = useTranslation();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [refreshData, setRefreshData] = React.useState<string>('groups');
  const [groups, setGroups] = React.useState<MeteringPointGroup[]>([]);
  const [showCreateModal, setShowCreateModal] = React.useState<boolean>(false);
  const [showEditModal, setShowEditModal] = React.useState<MeteringPointGroup | undefined>(undefined);

  React.useEffect(() => {
    async function getGroups(): Promise<void> {
      setLoading(true);
      const groups = await fetchMeteringPointGroups(userId);

      setGroups(groups.sort((a, b) => (a.groupName > b.groupName ? 1 : -1)));

      setRefreshData('');
      setLoading(false);
    }

    if (refreshData === 'groups') {
      getGroups();
    }
  }, [userId, refreshData]);

  const windowWidth = useWindowSize()[0];

  const isMobile = windowWidth < 768;

  return (
    <>
      <p className={styles.ingress}>{t(`consumption:meteringPointGroup.groupsManageIngress`)}</p>

      {!isMobile && (
        <>
          <header className={styles.groupHeader}>
            <div className={styles.buttons}>
              <Button
                type="button"
                onClick={(): void => {
                  setShowCreateModal(true);
                  setShowEditModal(undefined);
                }}
              >
                {t(`consumption:meteringPointGroup.createNewGroup`)}
              </Button>
            </div>
          </header>

          <Dialog openModal={showCreateModal} closeModal={() => setShowCreateModal(false)}>
            <ConsumptionMeteringPointGroupNew setShowCreateModal={setShowCreateModal} setRefreshData={setRefreshData} />
          </Dialog>
          <Dialog openModal={showEditModal ? true : false} closeModal={() => setShowEditModal(showEditModal)}>
            {showEditModal ? (
              <ConsumptionMeteringPointGroupEdit group={showEditModal} setShowEditModal={setShowEditModal} setRefreshData={setRefreshData} />
            ) : (
              <></>
            )}
          </Dialog>

          {loading && <Loading />}
          {!loading &&
            groups &&
            groups.map((g) => (
              <ConsumptionMeteringPointGroupAccordion
                key={g.identifier}
                type="update"
                group={g}
                setShowEditModal={setShowEditModal}
                setRefreshData={setRefreshData}
              />
            ))}
        </>
      )}
    </>
  );
};

export default ConsumptionMeteringPointGroupManage;
